export default __webpack_public_path__ + "static/media/symptoms.5722a1e6.svg";